<body>
    <div id="page" class="page">
       <!-- ***site header html start*** -->
       <app-smart-header></app-smart-header>
       <!-- ***site header html end*** -->
       <main id="content" class="site-main">
          <section class="contact-inner-page">
             <!-- ***Inner Banner html start form here*** -->
             <div class="inner-banner-wrap">
                <div class="inner-baner-container" style="background-image: url(assets/images/img7.jpg);">
                   <div class="container">
                      <div class="inner-banner-content">
                         <h1 class="page-title">FAQ</h1>
                      </div>
                   </div>
                </div>
             </div>
             <!-- ***Inner Banner html end here*** -->
             <!-- ***faq section html start form here*** -->
             <div class="faq-page-section">
                <div class="faq-page-container">
                   <div class="container">
                      <div class="row">
                         <div class="col-lg-6">
                            <div class="section-head">
                               <div class="sub-title">QUESTIONS / ANSWERS</div>
                               <h2 class="section-title">PREGUNTAS MÁS FRECUENTES</h2>
                               <p>Aperiam sociosqu urna praesent, tristique, corrupti condimentum asperiores platea ipsum ad arcu. Nostrud. Esse? Aut nostrum, ornare quas provident laoreet nesciunt odio voluptates etiam, omnis.</p>
                            </div>
                            <div id="accordion-tab-one" class="accordion-content" role="tablist">
                               <div id="accordion-A" class="card tab-pane fade show active" role="tabpanel" aria-labelledby="accordion-A">
                                  <div class="card-header" role="tab" id="qus-A">
                                     <h5 class="mb-0">
                                        <a data-bs-toggle="collapse" href="#collapse-one" aria-expanded="true" aria-controls="collapse-one">
                                           ¿ME PUEDEN AYUDAR A ENCONTRAR UNA UNIVERSIDAD?
                                        </a>
                                     </h5>
                                  </div>
                                  <div id="collapse-one" class="collapse show" data-bs-parent="#accordion-tab-one" role="tabpanel" aria-labelledby="qus-A">
                                     <div class="card-body">
                                        Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                     </div>
                                  </div>
                               </div>
                               <div id="accordion-B" class="card tab-pane" role="tabpanel" aria-labelledby="accordion-B">
                                  <div class="card-header" role="tab" id="qus-B">
                                     <h5 class="mb-0">
                                        <a class="collapsed" data-bs-toggle="collapse" href="#collapse-two" aria-expanded="false" aria-controls="collapse-two">
                                           ¿Me pueden ayudar a encontrar un programa de Máster?
                                        </a>
                                     </h5>
                                  </div>
                                  <div id="collapse-two" class="collapse" data-bs-parent="#accordion-tab-one" role="tabpanel" aria-labelledby="qus-B">
                                     <div class="card-body">
                                        Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                     </div>
                                  </div>
                               </div>
                               <div id="accordion-C" class="card tab-pane" role="tabpanel" aria-labelledby="accordion-C">
                                  <div class="card-header" role="tab" id="qus-C">
                                     <h5 class="mb-0">
                                        <a class="collapsed" data-bs-toggle="collapse" href="#collapse-three" aria-expanded="true" aria-controls="collapse-three">
                                           ¿Puedo extender mi visado de estudiante ?
                                        </a>
                                     </h5>
                                  </div>
                                  <div id="collapse-three" class="collapse" data-bs-parent="#accordion-tab-one" role="tabpanel" aria-labelledby="qus-C">
                                     <div class="card-body">
                                        Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                     </div>
                                  </div>
                               </div>
                            </div>
                         </div>
                         <div class="col-lg-6">
                            <div class="faq-testimonial">
                               <figure class="faq-image">
                                  <img src="assets/images/img29.jpg" alt="">
                               </figure>
                               <div class="testimonial-content">
                                  <span class="quote-icon">
                                     <i aria-hidden="true" class="icon icon-quote1"></i>
                                  </span>
                                  <p>Tempora sem nostrum porta libero ad parturient vestibulum laboriosam luctus dis, reprehenderit modi, felis esse laudan tium.</p>
                               </div>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <div class="faq-page-container bg-light-grey">
                   <div class="container">
                      <div class="row">
                         <div class="col-lg-8 offset-lg-2 text-sm-center">
                            <div class="section-heading">
                               <h5 class="sub-title">BENEFITS & AIM</h5>
                               <h2 class="section-title">BENEFITS AND WHAT WE DO?</h2>
                               <p>Fusce hic augue velit wisi quibusdam pariatur, iusto primis, nec nemo, rutrum. Vestibulum cumque laudantium. Sit ornare mollitia tenetur, aptent.</p>
                            </div>
                         </div>
                      </div>
                      <div class="row">
                         <div class="col-lg-6">
                            <div class="faq-content-wrap">
                               <div id="accordion-tab-two" class="accordion-content" role="tablist">
                                  <div id="accordion-E" class="card tab-pane fade show active" role="tabpanel" aria-labelledby="accordion-E">
                                     <div class="card-header" role="tab" id="qus-E">
                                        <h5 class="mb-0">
                                           <a data-bs-toggle="collapse" href="#collapse-five" aria-expanded="true" aria-controls="collapse-five">
                                              WHAT OUR TERMS AND CONDITION?
                                           </a>
                                        </h5>
                                     </div>
                                     <div id="collapse-five" class="collapse show" data-bs-parent="#accordion-tab-two" role="tabpanel" aria-labelledby="qus-E">
                                        <div class="card-body">
                                           Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                        </div>
                                     </div>
                                  </div>
                                  <div id="accordion-F" class="card tab-pane" role="tabpanel" aria-labelledby="accordion-F">
                                     <div class="card-header" role="tab" id="qus-F">
                                        <h5 class="mb-0">
                                           <a class="collapsed" data-bs-toggle="collapse" href="#collapse-six" aria-expanded="false" aria-controls="collapse-six">
                                              DO I HAVE TO MAKE RESERVATION?
                                           </a>
                                        </h5>
                                     </div>
                                     <div id="collapse-six" class="collapse" data-bs-parent="#accordion-tab-two" role="tabpanel" aria-labelledby="qus-F">
                                        <div class="card-body">
                                           Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                        </div>
                                     </div>
                                  </div>
                                  <div id="accordion-G" class="card tab-pane" role="tabpanel" aria-labelledby="accordion-G">
                                     <div class="card-header" role="tab" id="qus-G">
                                        <h5 class="mb-0">
                                           <a class="collapsed" data-bs-toggle="collapse" href="#collapse-seven" aria-expanded="true" aria-controls="collapse-seven">
                                              WHAT BENEFITS YOU GET FRIM BOOKING?
                                           </a>
                                        </h5>
                                     </div>
                                     <div id="collapse-seven" class="collapse" data-bs-parent="#accordion-tab-two" role="tabpanel" aria-labelledby="qus-G">
                                        <div class="card-body">
                                           Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                        </div>
                                     </div>
                                  </div>
                               </div> 
                            </div>
                         </div>
                         <div class="col-lg-6">
                            <div class="faq-content-wrap">
                               <div id="accordion-tab-three" class="accordion-content" role="tablist">
                                  <div id="accordion-I" class="card tab-pane fade show active" role="tabpanel" aria-labelledby="accordion-I">
                                     <div class="card-header" role="tab" id="qus-I">
                                        <h5 class="mb-0">
                                           <a data-bs-toggle="collapse" href="#collapse-nine" aria-expanded="true" aria-controls="collapse-nine">
                                              How do we manage to fund charity ?
                                           </a>
                                        </h5>
                                     </div>
                                     <div id="collapse-nine" class="collapse show" data-bs-parent="#accordion-tab-three" role="tabpanel" aria-labelledby="qus-I">
                                        <div class="card-body">
                                           Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                        </div>
                                     </div>
                                  </div>
                                  <div id="accordion-J" class="card tab-pane" role="tabpanel" aria-labelledby="accordion-J">
                                     <div class="card-header" role="tab" id="qus-J">
                                        <h5 class="mb-0">
                                           <a class="collapsed" data-bs-toggle="collapse" href="#collapse-ten" aria-expanded="false" aria-controls="collapse-ten">
                                              How did we manage your fund raised ?
                                           </a>
                                        </h5>
                                     </div>
                                     <div id="collapse-ten" class="collapse" data-bs-parent="#accordion-tab-three" role="tabpanel" aria-labelledby="qus-J">
                                        <div class="card-body">
                                           Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                        </div>
                                     </div>
                                  </div>
                                  <div id="accordion-K" class="card tab-pane" role="tabpanel" aria-labelledby="accordion-K">
                                     <div class="card-header" role="tab" id="qus-K">
                                        <h5 class="mb-0">
                                           <a class="collapsed" data-bs-toggle="collapse" href="#collapse-eleven" aria-expanded="true" aria-controls="collapse-eleven">
                                              How to donate your money for charity ?
                                           </a>
                                        </h5>
                                     </div>
                                     <div id="collapse-eleven" class="collapse" data-bs-parent="#accordion-tab-three" role="tabpanel" aria-labelledby="qus-K">
                                        <div class="card-body">
                                           Natoque consequat sodales autem nihil nec. Fusce molestias? Reiciendis voluptas, harum officia ante aliquet blanditiis scelerisque donec illo aperiam commodi hymenaeos.
                                        </div>
                                     </div>
                                  </div>
                               </div> 
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
             </div>
             <!-- ***faq section html start form here*** -->
          </section>
       </main>
       <!-- ***site footer html start form here*** -->
       
       <app-smart-footer></app-smart-footer>
       <!-- ***site footer html end*** -->
       <a id="backTotop" href="#" class="to-top-icon">
          <i class="fas fa-chevron-up"></i>
       </a>
       <!-- ***custom search field html*** -->
       <div class="header-search-form">
          <div class="container">
             <div class="header-search-container">
                <form class="search-form" role="search" method="get" >
                   <input type="text" name="s" placeholder="Enter your text...">
                </form>
                <a href="#" class="search-close">
                   <i class="fas fa-times"></i>
                </a>
             </div>
          </div>
       </div>
       <!-- ***custom search field html*** -->
       <!-- ***custom top bar offcanvas html*** -->
       <div id="offCanvas" class="offcanvas-container">
          <div class="offcanvas-inner">
             <div class="offcanvas-sidebar">
                <aside class="widget author_widget">
                   <h3 class="widget-title">OUR PROPRIETOR</h3>
                   <div class="widget-content text-center"> 
                      <div class="profile"> 
                         <figure class="avatar"> 
                            <img src="assets/images/img21.jpg" alt=""> 
                         </figure> 
                         <div class="text-content"> 
                            <div class="name-title"> 
                               <h4> James Watson</h4> 
                            </div> 
                            <p>Accumsan? Aliquet nobis doloremque, aliqua? Inceptos voluptatem, duis tempore optio quae animi viverra distinctio cumque vivamus, earum congue, anim velit</p> 
                         </div> 
                         <div class="socialgroup"> 
                            <ul> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-facebook"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-google"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-twitter"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-instagram"></i> </a> </li> 
                               <li> <a target="_blank" href="#"> <i class="fab fa-pinterest"></i> </a> </li> 
                            </ul> 
                         </div> 
                      </div> 
                   </div>
                </aside>
                <aside class="widget widget_text text-center">
                   <h3 class="widget-title">CONTACT US</h3>
                   <div class="textwidget widget-text">
                      <p>Feel free to contact and<br/> reach us !!</p>
                      <ul>
                         <li>
                            <a href="tel:+01988256203">
                               <i aria-hidden="true" class="icon icon-phone1"></i>
                               +01(988) 256 203
                            </a>
                         </li>
                         <li>
                            <a href="mailtop:info@domain.com">
                               <i aria-hidden="true" class="icon icon-envelope1"></i>
                               info@domain.com
                            </a>
                         </li>
                         <li>
                            <i aria-hidden="true" class="icon icon-map-marker1"></i>
                            3146 Koontz, California
                         </li>
                      </ul>
                   </div>
                </aside>
             </div>
             <a href="#" class="offcanvas-close">
                <i class="fas fa-times"></i>
             </a>
          </div>
          <div class="overlay"></div>
       </div>
       <!-- ***custom top bar offcanvas html*** -->
    </div>

   
 </body>